import '@babel/polyfill';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import { IntlProvider } from 'react-intl';
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import 'url-search-params-polyfill';
import { authenticateUser as authenticateUserAction } from "../../actions/loginActions";
import { clearMailData as clearMailDataAction } from "../../actions/mailActions";
import * as I18nUtil from '../../i18n/i18n.util';
import Routes from '../../routes/Routes';
import UserSettings from '../settings/model/Settings';

interface IAppProps extends RouteComponentProps<any> {
  isAuthenticated: boolean;
  settings: UserSettings;
  user: string;
  authenticateUser: (wsid: string, csrf: string, user: string) => (dispatch: Dispatch) => Promise<void>;
  clearMailData: () => any;
}

class App extends React.Component<IAppProps> {
  private wsidParam: any;
  private csrfParam: any;
  private userParam: any;

  constructor(props: IAppProps) {
    super(props);
    const urlQueryParams = new URLSearchParams(props.location.search);
    this.wsidParam = urlQueryParams.get('sessionID');
    this.csrfParam = urlQueryParams.get('csrf');
    this.userParam = urlQueryParams.get('user_name');

    I18nUtil.addLocales();

    props.clearMailData();
    if (this.wsidParam !== null && this.csrfParam !== null && this.userParam !== null) {
      props.authenticateUser(this.wsidParam, this.csrfParam, this.userParam);
    }
  }

  public render() {
    let lang = this.props.settings && this.props.settings.language ? this.props.settings.language : 'en';
    lang = lang.indexOf("fr") >= 0 ? lang.replace("_", "-") : lang.substring(0, 2);

    return (
      <IntlProvider locale={lang} messages={I18nUtil.translations[lang]} textComponent={React.Fragment}>
        <div>
          <div className="container-fluid">
            <FormattedMessage id="L.Title">
              {title => <Helmet><title>{title}</title></Helmet>}
            </FormattedMessage>
            <Routes isAuthenticated={this.props.isAuthenticated} />
          </div>
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    isAuthenticated: state.authentication.isAuthenticated,
    settings: state.settings.settings,
    user: state.authentication.user,
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    authenticateUser: bindActionCreators(authenticateUserAction, dispatch),
    clearMailData: bindActionCreators(clearMailDataAction, dispatch)
  };
}

export default withRouter(
  connect<{}, {}, IAppProps>(mapStateToProps, mapDispatchToProps)(App)
) as React.ComponentClass<{}>;



// WEBPACK FOOTER //
// ./src/components/app/App.tsx